// add all constant key used for job bucket
export const JOB_BUCKET_GROUP = {
  // CPP page company job buccket
  CPP_COMPANY_JOBS_BUCKET: 'cppJobsBucket',
  CPP_COMPANY_JOB_TITLE_JOBS_BUCKET: 'cppJobTitleJobsBucket',
  CPP_COMPANY_LOCATION_JOBS_BUCKET: 'cppLocationJobsBucket',

  CPP_FALLBACK_TO_PAID_JOBS: 'CPP_FALLBACK_TO_PAID_JOBS',

  // CPP page company competitios jobs bucket
  CPP_SIMILAR_COMPANY_JOBS_BUCKET: 'cppCompetitorJobsBucket',
  //CPP page company subsidiaries jobs bucket
  CPP_SUBSIDIARIES_COMPANY_JOBS_BUCKET: 'cppSubsidiariesJobsBucket',

  // Company review page job bucket
  COMPANY_REVIEW_JOB_BUCKET: 'companyReviewJobBucket',
  // Company review page competitors job bucket
  COMPANY_REVIEW_SIMILAR_JOB_BUCKET: 'companyReviewCompetitorJobBucket',
  // Job title review page job bucket
  JOB_TITLE_REVIEW_JOB_BUCKET: 'jobTitleReviewJobBucket',

  // Company jobs page bucket
  COMPANY_SIMILAR_JOBS: 'companySimilarJobs',

  // 1) resume job page bucket
  // 2) salary job page bucket
  // 3) trends job page bucket
  RESUME_JOBS_BUCKET: 'resumeJobTitleJobsBucket',

  // Salary Job Recently Added Jobs Bucket
  RECENT_SALARY_JOBS_BUCKET: 'recentSalaryJobTitleJobsBucket',

  // salary job page initial salary job bucket
  INITIAL_SALARY_JOBS_BUCKET: 'initialSalaryJobTitleJobsBucket',

  TITLE_INTERNSHIP_JOB_BUCKET: 'titleInternshipJobBucket',

  // DLP company job bucket
  COMPANY_JOBS_BUCKET: 'dlpCompanyJobsBucket',
  COMPANY_JOBS_BUCKET_PAGE: 'dlpCompanyJobsBucketPage',
  // DLP location job bucket
  LOCATION_JOBS_BUCKET: 'dlpLocationJobsBucket',
  LOCATION_JOBS_BUCKET_PAGE: 'dlpLocationJobsBucketPage',

  MOST_SIMILAR_JOBS: 'mostSimilarJobs',

  PAID_JOBS: 'paidJobs',

  PAID_JOBS_FC_CAREER_SALARY: 'paidJobsFCCareerSalary',

  // BCP pages jobs bucket

  BCP_COMPANY_JOB_BUCKET: 'bccJobsBucket',

  // compnay sitemap category and city page
  BEST_COMPANY_CITY: 'bestCompanySitemapCity',
  BEST_COMPANY_CATEGORY_CITY: 'bestCompanySitemapCategoryCity',

  // BCP state and state + category page
  BEST_COMPANY_STATE: 'bestCompanySitemapState',
  BEST_COMPANY_CATEGORY_STATE: 'bestCompanySitemapCategoryState',

  // my profile jobs
  MY_PROFILE_JOBS: 'myProfileJobs',
  MY_APPLIED_JOBS: 'myAppliedJobs',
  CAREER_JOBS_BUCKET_VERTICAL: 'careerJobsVertical',
  CAREER_CLUSTER_ADJECTIVE_PAGE: 'CAREER_CLUSTER_ADJECTIVE_PAGE',
  COMPANY_CLUSTER_ADJECTIVE_PAGE: 'COMPANY_CLUSTER_ADJECTIVE_PAGE',
  CAREER_REMOTE_VERTICAL: 'careerRemoteVertical',
  MY_SALARY_REPORT_JOBS: 'mySalaryReportJobs',
  // compnay sitemap category and state page
  COMPANY_SITEMAP_CATEGORY_STATE: 'companySitemapCategoryState',

  JOB_SEARCH_REMOTE_VERTICAL: 'jobSearchRemoteVertical',

  JOB_SEARCH_HIGH_SCHOOL_VERTICAL: 'jobSearchHighSchoolVertical',

  JOB_SEARCH_FOREIGN_WORKERS: 'jobSearchForeignWorker',

  JOB_SEARCH_LGBTQ_VERTICAL: 'jobSearchLGBTQVertical',

  JOB_SEARCH_REMOTE_COMPANIES: 'jobSearchRemoteCompanies',

  MAJOR_JOBS_BUCKET: 'jobSearchMajor',
  MAJOR_ENTRY_JOBS_BUCKET: 'jobSearchMajorEntry',

  CAREER_SKILLS_JOBS_BUCKET: 'careerSkills',

  CAREER_DEMOGRAPHICS_JOBS_BUCKET: 'careerDemographicsJobs',
  CAREER_DEMOGRAPHICS_COMPARE_JOBS: 'careerDemographicsCompareJobs',
  CAREER_DEMOGRAPHICS_COMPARE_GENDER_ETHIC_LANGUAGE: 'careerDemographicsCompareGenderEthicLanguage',
  CAREER_DEMOGRAPHICS_COMPARE_GENDER_RATIO: 'compareGenderRatioByJobTitle',
  CAREER_DEMOGRAPHICS_COMPARE_LGBT: 'compareGenderRatioLGBT',
  CAREER_DEMOGRAPHICS_COMPARE_AGE_BREAKDOWN: 'compareAgeBreakdown',
  CAREER_DEMOGRAPHICS_COMPARE_DURATION: 'compareDuration',
  CAREER_COMBO_SALARY_JOBS_BUCKET: 'careerComboSalaryJobs',
  CAREER_JOBS_OUTSIDE_BUCKET: 'careerJobsOutside',
  CAREER_CERTIFICATIONS_JOBS_BUCKET: 'careerCertificationsJobsBucket',
  TITLE_SENIOR_MID_LEVEL_BUCKET: 'titleSeniorMidLevelBucket',
  RECOMMENDED_JOBS_OUTSIDE_BUCKET: 'recommendedJobsOutsideBucket',
  SALARY_HISTORY_CHART: 'salaryHistoryChart',
  CAREER_BEST_STATES_BUCKET: 'careerBestStatesBucket',

  // <cityName>-jobs page
  FULL_TIME_JOBS_IN_CITY: 'fullTimeJobsInCity',
  JOBS_IN_CITY: 'jobsInCity',
  RECENTLY_VIEWED: 'recentlyViewed',
  JOBS_FROM_SEACH_API: 'JOBS_FROM_SEACH_API',
  JOBS_FROM_SEACH_API_2: 'JOBS_FROM_SEACH_API_2',

  STATE_JOBS: 'stateJobs',
  JOBS_IN_CITY_STATE: 'jobsInCityState',
  JOBS_IN_CITY_CLUSTER_ADJECTIVE: 'jobsInCityClusterAdjective',

  // <jobTitle>-<cityName>-jobs page
  ALL_JOBS_IN_CATEGORY: 'allJobsInCategory',

  // <jobTitle>-jobs page
  JOB_TITLE_JOB_BUCKET: 'jobTitleJobBucket',
  DASHBOARD_JOB_RECOMMENDED: 'dashboardJobRecommended',
  ENTRY_LEVEL_JOB_TITLE_JOB_BUCKET: 'entryLevelJobTitleJobBucket',
  RECENT_JOB_TITLE_JOB_BUCKET: 'recentJobTitleJobBucket',

  // <title>-major page
  JOBS_BY_MAJOR: 'jobsByMajor',
  ENTRY_LEVEL_JOBS_BY_MAJOR: 'entryLevelJobsByMajor',
  INTERNSHIP_JOBS_BY_MAJOR: 'internshipsJobsByMajor',
  MOST_POPULAR_JOBS_BY_MAJOR: 'mostPopularJobsByMajor',

  // CMP page
  BEFORE_JOBS_JOB_BUCKET: 'beforeJobsJobBucket',
  AFTER_JOBS_JOB_BUCKET: 'afterJobsJobBucket',

  // CMP WTD Featured Jobs
  WTD_FEATURED_JOBS: 'wtdFeaturedJobs',

  // CPP Salary
  RECENT_COMPANY_JOBS: 'recentCompanyJobs',

  // Answers bucket
  JOBS_BY_TITLE: 'jobsByTitle',
  JOBS_BY_COMPANY: 'jobsByCompany',
  JOBS_BY_LOCATION: 'jobsByLocation',
};

export const SALARY_HISTORY_LINE_CHART = 'Salary History Line Chart';

export const EVENTS = {
  redrawGraph: 'redrawGraph',
  nodeClicked: 'nodeClicked',
  drawSkillGraph: 'drawSkillGraph',
  performSearch: 'performSearch',
  signIn: 'signIn',
  dlpPageView: 'dlpPageView',
  profileField: 'profileField',
  bucketScrolled: 'bucketScrolled',
  deleteAccount: 'deleteAccount',
  jobCardSaveClick: 'jobCardSaveClick',
  jobCardDismissClick: 'jobCardDismissClick',
  dlpSaveJobClick: 'dlpSaveJobClick',
  dlpDismissJobClick: 'dlpDismissJobClick',
  filterClick: 'filterClick',
  viewFullListClick: 'viewFullListClick',
  expertAnswersBoxShowMoreClick: 'expertAnswersBoxShowMoreClick',
  adjustmentFilterClick: 'adjustmentFilterClick',
  carouselNavigationClick: 'carouselNavigationClick',
  rbSubscriptionPurchase: 'rbSubscriptionPurchase',
  checkoutPopupOpen: 'checkoutPopupOpen',
  checkoutPopupClose: 'closeCheckoutPopup',
  subscribeFormBtnClick: 'subscribeFormBtnClick',
};
export const REPORT_SALARY_SURVEY = '201';
export const REPORT_SALARY_SURVEY_FROM_MATCHES = '202';

export const WIDGET_NAMES = {
  BEST_STATES_MAP: 'best-states-map',
  TITLE_SALARY_STATES_MAP: 'salary-heatmap',
  TITLE_SALARY_ONLY_STATES_MAP: 'salary-only-state-heatmap',
  TITLE_LOCATION_STATES_MAP: 'location-heatmap',
  TITLE_DEMAND_STATES_MAP: 'demand-heatmap',
  MAJOR_SALARY_STATES_MAP: 'major-salary-map',
  CAREER_PATHS: 'career-paths',
  COLLEGE_MAJOR_PATHS: 'college-major-paths',
};

export const DLP_VIEW_SOURCE = {
  DEFAULT_PAGE_LOAD: 'defaultPageLoad',
  AFTER_PAID_CLICK: 'afterPaidClick',
  AFTER_SIGN_UP: 'afterSignUp',
  AFTER_FILTER_CHANGE: 'afterFilterChange',
};

export const RESUME_SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  NOT_ACTIVE: 'NOT_ACTIVE',
  CANCELLED: 'CANCELLED',
  DEACTIVATED: 'DEACTIVATED',
};

export const PAID_JOBS_CATEGORY = {
  CAREER_CLUSTER: 'careerCluster',
  LOCATION: 'location',
  RECOMMENDED: 'recommended',
  RECOMMENDED_TITLE: 'recommendedTitle',
  COMPANY_CLUSTER: 'companyCluster',
  COMPANY_CATEGORIES: 'companyCategories',
};

export const CLUSTER_HEADER_CATEGORY = {
  CAREER: 'career',
  COMPANY: 'company',
  CAREER_COMBO: 'career-combo',
  MAJOR: 'major',
  REMOTE: 'remote',
  LGBTQ: 'lgbtq',
  FOREIGN_WORKERS: 'foreign-workers',
  HIGH_SCHOOL: 'high-school',
  CAREER_SALARY: 'career-salary',
  CAREER_COMBO_SALARY: 'career-combo-salary',
  COMPANY_SALARY: 'company-salary',
  PROFILE: 'profile',
  JOB_SEARCH: 'job-search',
  CITY: 'city',
  COMPANY_FAQ: 'company-faq',
};

export const CMP_SUBPAGES = {
  SKILLS: 'skills',
  BEST_STATES: 'best-states',
  SALARY: 'salary',
  RESUME: 'resume',
  JOBS: 'jobs',
  DYNAMIC: 'dynamic',
  WHAT_THEY_DO: 'what-they-do',
  HOW_TO_BECOME: 'how-to-become',
  REMOTE_JOBS: 'remote-jobs',
  TRENDS: 'trends',
  OVERVIEW: 'overview',
  REVIEWS: 'reviews',
  EDUCATION: 'education',
  DEMOGRAPHICS: 'demographics',
  CERTIFICATIONS: 'certifications',
  DESCRIPTION: 'job-description',
};

export const MAJOR_SUBPAGES = {
  SALARY: 'salary',
  BEST_COLLEGES: 'best-colleges',
};

export const MODERATION_STATUS_LIST = {
  approved: 'APPROVED',
  deferred: 'DEFERRED',
  rejected: 'REJECTED',
  pending: 'PENDING',
};
export const CPP_SUBPAGES = {
  OVERVIEW: 'overview',
  JOBS: 'jobs',
  SALARY: 'salary',
  HISTORY: 'history',
  REVIEWS: 'reviews',
  LOCATIONS: 'locations',
  EXECUTIVES: 'executives',
  REVENUE: 'revenue',
  DEMOGRAPHICS: 'demographics',
  JOB_TITLE_COMBO_JOBS: 'job-title-combo-jobs',
  LOCATION_COMBO_JOBS: 'location-combo-jobs',
  JOB_TITLE_SALARY: 'job-title-salary',
  FAQ: 'faqs',
  CITY_SALARY: 'city-salary',
  STATE_SALARY: 'state-salary',
};

export const POPUP_ENTRY_POINT = {
  SHOW_MORE_POPUP: 'Show More Popup',
  SCROLL_BUCKET_POPUP: 'Scroll Bucket Popup',
};

export const POPUP_SURVEY_SOURCE = {
  POPUP_BUCKET_SCROLL: 'popup-bucket-scroll',
  POPUP_SHOW_MORE: 'popup-show-more',
  POPUP_SESSION_DURATION: 'popup-session-duration',
  POPUP_SAVE: 'popup-save',
  POPUP_DISMISS: 'popup-dismiss',
  MAJOR: 'major',
  MATCHES_PAGE: 'matches-page',
  MATCHES_SALARY_PAGE: 'matches-salary-page',
  CMP_PAGE: 'cmp-page',
  CMP_OVERVIEW_PAGE: 'cmp-overview',
  MAJOR_PAGE: 'major-page',
  CAREER_SALARY_PAGE: 'career-salary-page',
  CMP_SALARY_PAGE: 'jobtitle-salary-overview',
  CPP_SALARY_PAGE: 'company-salary-overview',
  CPP_LOCATION_HEADQUARTERS_AND_OFFICES: 'company-location-headquarters-and-offices',
  CPP_LOCATION_HEADER: 'company-location-header',
  CPP_HISTORY_SUMMMARY_BOX: 'company-history-summary-box',
  CPP_HISTORY_ABOUT_LINK: 'company-history-about-link',
  CPP_HISTORY_ABOUT_CARD: 'company-history-about-card',
  CPP_HISTORY_SIMILAR_BOX: 'company-history-similar-box',
  SURVEY_ONE_TAP: 'survey-core-prompt',
  COMPANY_FOLLOW: 'company-follow',
  POST_APPLY_UX_END: 'post-apply-ux-end',
  REMOTE_JOBS_PAGE: 'remote-jobs-page',
  CMP_SALARY_NUM_CALLOUT: 'salarynum-callout',
  BEST_STATES_ANIMATION: 'best-states-animation',
};

export const SIGN_UP_ERRORS = {
  emailAlreadyTaken: 'Email address already taken!',
  invalidEmail: 'Please enter a valid email',
};

export const RECAPTCHA_SITE_KEY = '6LdVkakZAAAAAOhLW02JeSA0jzM_bWgEWBXQdEBh';

export const BCP_NON_CACHED_CATEGORIES = [
  {
    name: 'Most Diverse',
    apiField: 'unifiedWorkEnvironment',
  },
  {
    name: 'Best Paying',
    apiField: 'unifiedSalary',
  },
];

export const USER_JOB_SITUATION = {
  USER_SPECIFIED: { source: 'user-specified', confidence: 10 },
  DATA_ANALYSIS: { source: 'data-analysis', confidence: 9 },
  BEHAVIOR_ANALYSIS: { source: 'behavior-analysis', confidence: 8 },
};

export const HASH_SUFFIX = '-ish';

export const PUSH_ACTIVITY_TYPES = {
  PUSH_SUBSCRIBED: 'PUSH_SUBSCRIBED',
  PUSH_UNSUBSCRIBED: 'PUSH_UNSUBSCRIBED',
};

export const SIGN_UP_PROMPT_TYPE = {
  POP_UP_SESSION_DURATION: 'popup-session-duration',
  POP_UP_PARTIAL_GATE: 'popup-partialGate'
}

export const USER_ACTIVITY_EVENTS = {
  HTTP: {
    HTTP_ACTIVITY: 'HTTP_ACTIVITY',
  },
  SURVEY: {
    SAVE_SEARCH: 'SAVE_SEARCH',
    SURVEY_ACTIVITY: 'SURVEY_ACTIVITY',
    AUTOCOMPLETE_SEARCH: 'AUTOCOMPLETE_SEARCH',
  },
  SIGN_UP: {
    SIGN_UP_POPUP: 'SIGN_UP_POPUP',
    EMAIL_ACTIVITY: 'EMAIL_ACTIVITY',
    SIGN_UP_ACTIVITY: 'SIGN_UP_ACTIVITY',
  },
  JOB_OPENING: {
    JOB_OPENING_VIEWED: 'JOB_OPENING_VIEWED',
    JOB_OPENING_SAVED_DLP: 'JOB_OPENING_SAVED_DLP',
    JOB_OPENING_SAVED_CARD: 'JOB_OPENING_SAVED_CARD',
    JOB_OPENING_VIEWED_DLP: 'JOB_OPENING_VIEWED_DLP',
    JOB_OPENING_APPLIED_DLP: 'JOB_OPENING_APPLIED_DLP',
    JOB_OPENING_JOB_CLICKED: 'JOB_OPENING_JOB_CLICKED',
    JOB_OPENING_DISMISSED_DLP: 'JOB_OPENING_DISMISSED_DLP',
    JOB_OPENING_DISMISSED_CARD: 'JOB_OPENING_DISMISSED_CARD',
    JOB_OPENING_JOB_CLICKED_DLP: 'JOB_OPENING_JOB_CLICKED_DLP',
  },
  PUSH_NOTIFICATION: {
    PUSH_ACTIVITY: 'PUSH_ACTIVITY',
    BROWSER_NOTIFICATIONS_ACTION: 'BROWSER_NOTIFICATIONS_ACTION',
    BROWSER_NOTIFICATIONS_PROMPT: 'BROWSER_NOTIFICATIONS_PROMPT',
  },
  PROFILE: {
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    PROFILE_NOTIFICATION_UPDATE: 'PROFILE_NOTIFICATION_UPDATE',
  },
  REVIEW: {
    REVIEW_POPUP: 'REVIEW_POPUP',
    REVIEW_SUBMITTED: 'REVIEW_SUBMITTED',
  },
  SP_POP_OUT: {
    SP_POP_OUT_DISPLAYED: 'SP_POP_OUT_DISPLAYED',
    SP_POP_OUT_CLICKED: 'SP_POP_OUT_CLICKED',
    SP_POP_OUT_VIEWED_DLP: 'SP_POP_OUT_VIEWED_DLP'
  },
};

export const TRACKING = {
  LOG_ACTIVITY: {
    AUTO_COMPLETE: 'AUTO_COMPLETE',
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    COMPANY_REVIEW_SUBMITTED: 'COMPANY_REVIEW_SUBMITTED',
    JOB_UPLOAD_RESUME: 'JOB_UPLOAD_RESUME',
    DLP: 'DLP',
    SP_POP_OUT: 'SP_POP_OUT',
    HEADER_SEARCH: 'HEADER_SEARCH',
  },
  SOURCES: new Map(
    Object.entries({
      TMP: { param: 'clickID' },
      RD: { param: 'clickId' },
    })
  ),
  PIXEL_SOURCES: new Map(
    Object.entries({
      talroo: { src: 'https://www.jobs2careers.com/conversion2.php?p=5116' },
    })
  ),
};

export const ANSWERS = {
  TYPE: {
    JOB_TITLE: 'JOB_TITLE',
    COMPANY: 'COMPANY',
    MAJOR: 'MAJOR',
    CITY: 'CITY',
    STATE: 'STATE',
    BLOG: 'BLOG',
  },
  CATEGORY: {
    JOB_TITLE: 'JOB_TITLE',
    LOCATION: 'LOCATION',
    COMPANY: 'COMPANY',
    JOB_SEARCH: 'JOB_SEARCH',
  },
};

export const SIGN_UP_STATUSES = {
  EXIST: 'userAlreadyExists',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const MEDIAN_SALARY_THRESHOLD = 35000;

export const HIDE_GOOGLE_ADS_ROUTES = ['/resume-builder/', '/my-resume/'];
export const GOOGLE_AD_SENSE_PUBLIC_KEY = 'ca-pub-5822163099292706';

export const RESUME_BUILDER_CATEGORY = {
  STEPS: 'Resume Builder',
  LANDING: 'Resume Builder Promo Page',
};

export const CITY_SUBPAGES = {
  JOB: 'city-job-page',
  SALARY: 'city-salary-page',
  PART_TIME_JOBS: 'city-part-time-jobs-page',
};

export const RESUME_TEMPLATES_ORDER = [
  'ColorTheme1',
  'ColorTheme2',
  'ColorTheme5',
  'ColorTheme4',
  'ColorTheme3',
  'TextTheme4',
  'TextTheme7',
  'TextTheme3',
  'TextTheme1',
  'TextTheme6',
  'TextTheme2',
  'TextTheme5',
];

export const RBFormatWidgetType = {
  RANGE: 'range',
  COLOR_PALETTE: 'color_palette',
  DROPDOWN: 'dropdown',
};

export const RBFormatFields = {
  COLOR: {
    name: 'Color',
    value: 'color',
  },
  TEXT_SIZE: {
    name: 'Text Size',
    value: 'textSize',
  },
  LINE_SPACING: {
    name: 'Line Spacing',
    value: 'lineSpacing',
  },
  SECTION_SPACING: {
    name: 'Section Spacing',
    value: 'sectionSpacing',
  },
};

export const HOURS_IN_YEAR = 2080;

export const RESUME = {
  CONTACT_TYPES: {
    EMAIL: 'email',
    PHONE: 'phone',
    LOCATION: 'location',
  },
};

export const JOB_SNIPPET_PRIORITY = {
  TITLE: ['title', 'location', 'company'],
  COMPANY: ['company', 'location', 'title'],
  LOCATION: ['location', 'title', 'company'],
};

// Career How To Become data.articles[i].post_subtype values.
export const HOW_TO_BECOME_STEPS = {
  CERTIFICATION_STEP: 'certification-step',
  DUTIES_STEP: 'duties-step',
  EDUCATION_STEP_MAJORS: 'education-step-majors',
  EDUCATION_STEP: 'education-step',
  EXPERIENCE_STEP: 'experience-step',
  JOB_STEP: 'job-step',
  LICENSE_STEP: 'license-step',
  RESUME_STEP: 'resume-step',
  SKILLS_STEP: 'skills-step',
  TRAINING_STEP: 'training-step',
};
